<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'国外市场'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder ljjclassdate">
						<div class="h-thirdColumn">
							<el-form-item label="创建时间" style="margin-left: 0.2rem;">
								<el-date-picker style="width: 1.5rem;"
									placeholder="请选择"
									v-model="q.cdateBegin"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								至
								<el-date-picker style="width:1.5rem;"
									placeholder="请选择"
									v-model="q.cdateEnd"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item label="国家名称">
							    <brselectlazy placeholder="请选择"
									  category="YLCountry_agent"
									  :v="q.country"
									  clearable
									  v-model="q.country">
							    </brselectlazy>
							</el-form-item>
							
							<el-form-item label="常规或改制">
							    <brselect
							            category="shifou_dingzhi"
							            :v="q.isSpecific"
							            v-model="q.isSpecific"
							            clearable>
							    </brselect>
							</el-form-item>
						</div>	
                        <div class="h-thirdColumn">
                        	
                        	<el-form-item label="预测单编号">
                        	    <el-input
                        	            v-model="q.id"
                        	            placeholder="请输入"
                        	            clearable>
                        	    </el-input>
                        	</el-form-item>
                        	<el-form-item label="是否审核" style="margin-left: 0.8rem;">
                        	    <brselect
                        	            category="shifou_keyong"
                        	            :v="q.isDel"
                        	            v-model="q.isDel"
                        	            clearable>
                        	    </brselect>
                        	</el-form-item>
                        	<el-form-item label="产品大类">
                        	    <brselect
                        	            category="product_level"
                        	            :v="q.cpdlCode"
                        	            v-model="q.cpdlCode"
                        	            clearable>
                        	    </brselect>
                        	</el-form-item>
                        </div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn">
									<el-form-item label="产品型号" style="margin-left: 0.2rem;">
									    <el-input
									            v-model="q.proModel"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
									<el-form-item label="产品编码" style="margin-left: 0.6rem;">
									    <el-input
									            v-model="q.proCode"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
									<el-form-item label="创建人">
									    <el-input
									            v-model="q.cuname"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
								</div>
								<el-form-item label="预计交货期">
									<el-date-picker style="width: 1.5rem;"
										placeholder="请选择"
										v-model="q.deliveryDateBegin"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
									</el-date-picker>
									至
									<el-date-picker style="width:1.5rem;"
										placeholder="请选择"
										v-model="q.deliveryDateEnd"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
							</div>
						</el-collapse-transition>
						<!-- <div class="h-formBtnOut h-columnCenter">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div> -->
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            @selection-change="handleSelectionChange"
                            stripe
                            :border="true"
							max-height="500"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="55"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                fixed
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                label="国家名称"
                                width="120"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
						<el-table-column
						        prop="proModel"
						        label="产品型号"
						        min-width="200"
						        :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
						        prop="proCode"
						        width="160"
						        label="产品编码"
						        :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
						        prop="cuname"
						        label="创建人"
						        width="100"
						        :show-overflow-tooltip="true">
						</el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="protype"
                                label="型号属性"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        
                        <el-table-column
                                prop="proNumber"
                                label="数量"
                                width="90"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="useNumber"
                                label="可使用数量"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="useInventory"
                                :show-overflow-tooltip="true"
                                width="130"
                                label="使用库存数量">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.useInventory"
                                          placeholder="库存数量"
                                          :disabled="!(scope.row.forecastStatus == 3 && scope.row.schedulingStatus == '未排产' && a == 1)"
                                          class="h-tableInput ljjtableinput"
                                          style="height: 0.3rem;"
                                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isSpecific"
                                width="120"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
                                label="改制需求描述"
                                width="300"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specificReq}}
                                </div>
                            </template>
                        </el-table-column>
						<el-table-column
						        prop="specificReq"
						        label="占用预测库存信息"
						        width="300"
						        :show-overflow-tooltip="true">
						    <template slot-scope="scope">
						        <div style="text-align: left;">
						            {{scope.row.specificReq}}
						        </div>
						    </template>
						</el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注"
                                width="300"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.remark}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
                                label="预计交货期"
                                width="140"
                                :show-overflow-tooltip="true">
                        </el-table-column>
						<el-table-column
						        prop="forecastStatus"
						        label="预测状态"
						        width="120"
						        :show-overflow-tooltip="true">
						    <template slot-scope="scope">
						        <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
						    </template>
						</el-table-column>
                        <el-table-column
                                fixed="right"
                                width="320"
                                label="操作">
                            <template slot-scope="scope">
                                <div>
                                    <el-button
                                            @click="showRow(scope.row.id, scope.row.status)"
                                            type="text"
                                            size="small" class="h-tableLink h-btn">查看
                                    </el-button>
                                    <el-button
                                            @click="revise(scope.row.id, scope.row.status)"
                                            type="text"
                                            style="margin-left: 0;"
                                            size="small" class="h-tableLink h-btn">编辑
                                    </el-button>
                                    <el-button
                                            @click.native.prevent="delRow(scope.row)"
                                            type="text"
                                            style="margin-left: 0;"
                                            size="small" class="h-tableLink h-btn">删除
                                    </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            style="margin-left: 0;"
                                            @click="genzongLiuch(scope.row)">
                                        跟踪审批
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="q" @query="handlelist"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60" v-auth="'xgkc'">
                <!--<el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="reviseInventory">确定修改</el-button>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                multipleSelection: [],
                tableData: [],
                userRole: [],
                // zcData:[],
                a: '',
                loadFlag: '',
                timeValue1: '',
                timeValue2: '',
                instid: '',
                showhistory: false,
                q: {
                    idlist: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
            }
        },
        mounted() {

        },
        created() {
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            // lockOrder() {
            //     this.$msg.confirm("确认锁定?", () => {
            //         ss.waixiao.lockOrder(this.multipleSelection).then(rd => {
            //             if (rd.f == true) {
            //                 this.loadFlag = 1;
            //                 this.$msg.msgs(rd.msg);
            //             } else {
            //                 this.$msg.msge(rd.msg);
            //             }
            //
            //         })
            //     });
            // },
            genzongLiuch(v) {
                console.log(v.instId);
                this.instid = v.instId;
                this.showhistory = true;
            },
			delRow(row){
				this.$msg.confirm("确认删除?", () => {
				    ss.wxhuizong.deleteId(row.id).then(rd => {
				        this.$msg.msgs(rd.msg);
				        this.query();
				    })
				})
			},
            revise(v) {
                this.$router.push({path: "/yuce/export_list", query: {bid: v, bstatus: s}});
            },
            reviseInventory() {
                this.$msg.confirm("确认修改?", () => {
                    ss.waixiao.reviseInventory(this.tableData).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                });
            },
            showRow(id) {
                this.$router.push({path: "/yuce/wxxiangqing", query: {id: id, status: status}})
            },
            timeSelect1() {
                if (this.timeValue1) {
                    this.q.cdateBegin = this.timeValue1[0];
                    this.q.cdateEnd = this.timeValue1[1];
                } else {
                    this.q.cdateBegin = '';
                    this.q.cdateEnd = '';
                }
            },
            timeSelect2() {
                if (this.timeValue2) {
                    this.q.deliveryDateBegin = this.timeValue2[0];
                    this.q.deliveryDateEnd = this.timeValue2[1];
                } else {
                    this.q.deliveryDateBegin = '';
                    this.q.deliveryDateEnd = '';
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            resetData() {
                this.q.id = '';
                this.q.country = '';
                this.timeValue1 = '';
                this.q.cdateBegin = '';
                this.q.cdateEnd = '';
                this.timeValue2 = '';
                this.q.deliveryDateBegin = '';
                this.q.deliveryDateEnd = '';
                this.q.isSpecific = '';
                this.q.isDel = '';
                this.q.lockStatus = '';
                this.q.cpdlCode = '';
                this.q.cuname = '';
                this.q.proModel = '';
                this.q.proCode = '';
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.query();
            },
            //明细导出
            exportExcel() {
                this.q.idlist = [];
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.q.idlist.push(element.id);
                    });
                }
                updownfile.down("/api/swyl/v1/demo/viewWxycReport/downloadreportExcel", this.q, "post", 'data');
            },
            query() {
                this.userRole = this._user.roles;
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_admin" || item.id == "swyl_waixiaogly") {
                        this.a = 1;
                        return;
                    }
                })
                ss.waixiao.showReportPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    // ss.waixiao.selectList(this.q).then(rd => {
                    //     this.zcData = rd;
                    // })
                })
            },
            handleFilter() {
                this.q.pageNo = 1;
                ss.waixiao.showReportPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    // ss.waixiao.selectList(this.q).then(rd => {
                    //     this.zcData = rd;
                    // })
                })
            },
            handlelist() {
                ss.waixiao.showReportPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    // ss.waixiao.selectList(this.q).then(rd => {
                    //     this.zcData = rd;
                    // })
                })
            },
            // gettabledata(xs){
            //     xs.forEach((item, index) => {
            //         ss.waixiao.selectAllPlan(item.id).then(rd => {
            //
            //             item.shengchanId = rd.aufnr;
            //             item.orderStatus = rd.orderStatus;
            //             item.finishTime = rd.gstrp;
            //         })
            //     })
            //     setTimeout(res=>{
            //         this.tableData = xs;
            //         console.log(this.tableData,"///////////////////");
            //     },1000)
            // },
            renovate() {
                this.$router.push({path: "/yuce/wxhuizong"});
            },
        }
    }
</script>
<style>
    .ljjclassdate .el-date-editor .el-range-separator {
        width: 8%;
    }

    .ljjtableinput .el-input__inner {
        padding: 0.1rem 0.1rem;
    }
</style>